import React from 'react';
import { CStatus, CType } from 'entities/card/model/types';
import cardBg from 'shared/assets/images/cardBg_new.png';
import styles from './CardIcon.module.scss';
import clsx from 'clsx';
import { Flex, Typography } from 'antd';
import RoundContainer from '../RoundContainer/RoundContainer';
import { Icon } from '@iconify-icon/react';
import StatusOverlay from './StatusOverlay';

type CardIconProps = {
  size?: 's' | 'l';
  type?: CType;
  status?: CStatus;
  cardNumber: string;
  accountTitle?: string;
  balance?: number;
};

const Background = ({ width, height }: { width: number | string; height: number | string }) => (
  <div>
    <img
      src={cardBg}
      width={width}
      height={height}
      style={{ position: 'absolute', top: 0, left: 0 }}
      alt=''
    />
  </div>
);

const CardIcon: React.FC<CardIconProps> = ({
  size = 's',
  type = CType.Physical,
  status = CStatus.Active,
  cardNumber,
  accountTitle,
  balance
}) => {

  if (size === 's')
    return (
      <div className={clsx(styles.container, styles.container_s)}>
        <StatusOverlay status={status} />
        <Background width='100%' height='100%' />
        <Typography.Text className={styles.cardNumber_s}>{cardNumber.slice(-4)}</Typography.Text>
      </div>
    );

  // Format balance (European format with comma)
  const formatBalance = (amount?: number) => {
    if (amount === undefined || amount === null) return null;
    const fixed = amount.toFixed(2);
    const [whole, fractional] = fixed.split('.');
    // Format whole part with thousands separator
    const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return { whole: formattedWhole, fractional };
  };

  const balanceFormatted = formatBalance(balance);

  return (
    <div className={clsx([styles.container, styles.container_l])}>
      <StatusOverlay size='l' status={status} />

      {type === CType.Virtual && (
        <div
          style={{
            position: 'absolute',
            top: 90,
            right: 20,
            zIndex: 999
          }}>
          <RoundContainer color='rgba(0,0,0,0.08)' size={50}>
            <Icon icon='ant-design:cloud-filled' width='25' height='25' style={{ color: 'white' }} />
          </RoundContainer>
        </div>
      )}
      <Background width='100%' height='100%' />
      <Flex vertical justify='space-between' style={{ height: '100%', padding: '16px' }}>
        <div className={styles.cardHeader}>
          <div className={styles.cardTopLeft}>
            {accountTitle && (
              <Typography.Text className={styles.accountTitle}>{accountTitle}</Typography.Text>
            )}
            {balanceFormatted && (
              <Typography.Text className={styles.balance}>
                €{balanceFormatted.whole}
                <span className={styles.balanceFractional}>,{balanceFormatted.fractional}</span>
              </Typography.Text>
            )}
          </div>
        </div>
        <div className={styles.cardFooter}>
          <Typography.Text className={styles.cardNumber_l}>
            {cardNumber && `•${cardNumber.slice(-4)}`}
          </Typography.Text>
        </div>
      </Flex>
    </div>
  );
};

export default CardIcon;
